/* Tæller artikeltallene op på hub-siden, når fliserne kommer i billedet.

   IntersectionObserver frem for scroll-events: temaet lader ikke scroll-events nå
   frem til lyttere på window (målt til nul under en fuld gennemscrollning), så en
   scroll-baseret løsning ville aldrig starte. Det rigtige tal står allerede i HTML'en,
   så uden JavaScript — eller hvis noget går galt — ser man bare tallet med det samme.

   Optællingen springes helt over, hvis brugeren har bedt om mindre bevægelse. */
(function () {
  var nums = document.querySelectorAll('.pd-hub__num[data-count]');
  if (!nums.length) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;

  function countUp(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    if (isNaN(target) || target <= 0) return;

    var duration = 900;
    var start = null;

    el.textContent = '0';

    function step(now) {
      if (start === null) start = now;
      var progress = Math.min((now - start) / duration, 1);
      // Blød opbremsning, så tallet lander frem for at stoppe brat.
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = String(Math.round(target * eased));
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      countUp(entry.target);
    });
  }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });

  Array.prototype.forEach.call(nums, function (el) { observer.observe(el); });
})();
